import React from 'react';
import { useSEO } from '../hooks/useSEO';
import Hero from '../components/Hero';
import ImpactStats from '../components/ImpactStats';
import OurStorySection from '../components/OurStorySection';
import ProgramsSection from '../components/ProgramsSection';
import StoriesSection from '../components/StoriesSection';
import NewsSection from '../components/NewsSection';
import VolunteerCTA from '../components/VolunteerCTA';
import { EditRegion } from '../components/AdminEditBar';
import PartnersMarquee from '../components/PartnersMarquee';

export default function Home() {
  useSEO('home');
  return (
    <>
      <EditRegion label="Hero Slider" to="/admin/hero"><Hero /></EditRegion>
      {/* Partners marquee — live sponsors from admin */}
      <EditRegion label="Destekçilerimiz" to="/admin/sponsors"><PartnersMarquee /></EditRegion>
      <EditRegion label="Hikâyemiz" to="/admin/homepage"><OurStorySection /></EditRegion>
      <EditRegion label="Etkimiz (KPI)" to="/admin/homepage"><ImpactStats /></EditRegion>
      <EditRegion label="Programlar" to="/admin/homepage"><ProgramsSection /></EditRegion>
      <EditRegion label="Bursiyer Alıntısı" to="/admin/homepage"><StoriesSection /></EditRegion>
      <EditRegion label="Duyurular" to="/admin/news"><NewsSection /></EditRegion>
      <EditRegion label="Gönüllü CTA" to="/admin/homepage"><VolunteerCTA /></EditRegion>
    </>
  );
}
